export const headers = {
    initialHeaders: [
        {title:"Nombre del empleado", field: "fullName", child: null},
        //{title:"Apellido", field: "surname", child: null},
        {title:"Cargo", field: "charge", child: null},
        {title:"Regional", field: "employeeRequesting", child: "regional"},
    ]
}